import { SdgAlignmentsLayout, SdgAlignmentStrength } from '@upright/common/model/output/scores/sdg-alignment/types';
import { BouColor } from '@upright/ui/common/generic/global/bou-colors';
// eslint-disable-next-line upright/no-platform-color
import { PlatformColor } from '@upright/ui/common/generic/global/platform-colors';
import { mobileOrNarrower } from '@upright/ui/common/generic/layout/breakpoint-utils';
import { css } from 'styled-components';
import { SdgAlignmentValence } from '../../../../../../../common/model/output/scores/sdg-alignment/types';

export function getSdgRowHeight(layout?: SdgAlignmentsLayout) {
  switch (layout) {
    case 'tight':
      return '3em';
    case 'normal':
    default:
      return '6em';
  }
}

export function getSdgIconSize(layout?: SdgAlignmentsLayout) {
  switch (layout) {
    case 'tight':
      return '2em';
    case 'normal':
    default:
      return '4.1em';
  }
}

const ICON_AND_NAME_AREA_WIDTH = 40;
const ALIGNMENT_AREA_WIDTH = 100 - ICON_AND_NAME_AREA_WIDTH;

const ICON_WIDTH_MOBILE = 16;
const ALIGNMENT_AREA_WIDTH_MOBILE = 100 - ICON_WIDTH_MOBILE;

export const sdgIconAndNameWidth = css`
  width: ${ICON_AND_NAME_AREA_WIDTH}%;
  ${mobileOrNarrower(css`
    width: ${ICON_WIDTH_MOBILE}%;
  `)}
`.join('');

export const sdgAlignmentAreaWidth = css`
  width: ${ALIGNMENT_AREA_WIDTH}%;
  ${mobileOrNarrower(css`
    width: ${ALIGNMENT_AREA_WIDTH_MOBILE}%;
  `)}
`.join('');

export function getSdgColor(valence: SdgAlignmentValence, strength: SdgAlignmentStrength): BouColor {
  if (valence === SdgAlignmentValence.ALIGNED && strength === SdgAlignmentStrength.STRONG) {
    return BouColor.SDG_STRONGLY_ALIGNED_GREEN;
  }
  if (valence === SdgAlignmentValence.ALIGNED && strength === SdgAlignmentStrength.NORMAL) {
    return BouColor.SDG_ALIGNED_GREEN;
  }
  if (valence === SdgAlignmentValence.ALIGNED && strength === SdgAlignmentStrength.WEAK) {
    return BouColor.SDG_WEAKLY_ALIGNED_GREEN;
  }
  if (valence === SdgAlignmentValence.MISALIGNED && strength === SdgAlignmentStrength.NORMAL) {
    return BouColor.SDG_MISALIGNED_PURPLE;
  }
  if (valence === SdgAlignmentValence.MISALIGNED && strength === SdgAlignmentStrength.STRONG) {
    return BouColor.SDG_STRONGLY_MISALIGNED_PURPLE;
  }
  if (valence === SdgAlignmentValence.MISALIGNED && strength === SdgAlignmentStrength.WEAK) {
    return BouColor.SDG_WEAKLY_MISALIGNED_PURPLE;
  }
  throw Error('Incorrect SDG alignment details');
}

export function getSdgTextColorOnColoredBackground(valence: SdgAlignmentValence, strength: SdgAlignmentStrength) {
  const backgroundColor = getSdgColor(valence, strength);
  switch (backgroundColor as BouColor) {
    case BouColor.SDG_WEAKLY_MISALIGNED_PURPLE:
      return PlatformColor.SDG_MISALIGNED_WEAK_FG;
    case BouColor.SDG_MISALIGNED_PURPLE:
      return PlatformColor.SDG_MISALIGNED_MODERATE_FG;
    case BouColor.SDG_STRONGLY_MISALIGNED_PURPLE:
      return PlatformColor.SDG_MISALIGNED_STRONG_FG;
    case BouColor.SDG_WEAKLY_ALIGNED_GREEN:
      return PlatformColor.SDG_ALIGNED_WEAK_FG;
    case BouColor.SDG_ALIGNED_GREEN:
      return PlatformColor.SDG_ALIGNED_MODERATE_FG;
    case BouColor.SDG_STRONGLY_ALIGNED_GREEN:
      return PlatformColor.SDG_ALIGNED_STRONG_FG;
    default:
      return 'black';
  }
}
